export default function Section3() {
	return (
		<section className="bg-[#0b3067] px-10 md:px-40 py-20">
			<h3 className="text-white">
				Nuestro compromiso es satisfacer todas esas expectativas y asegurarnos
				de que tenga una experiencia complaciente y excelente sin excepciones.
				Prometemos máxima satisfacción con cada auto que usted rente.
			</h3>
		</section>
	);
}
